// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EXR5","top":"styles_top__1xvtI"};